var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoPlannedConsultation = function SvgNoPlannedConsultation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 171 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.4637 168.175C131.605 168.175 169.011 130.77 169.011 84.6283C169.011 38.4866 131.605 1.0814 85.4637 1.0814C39.322 1.0814 1.9167 38.4866 1.9167 84.6283C1.9167 130.77 39.322 168.175 85.4637 168.175Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3028 13.5568C33.7111 13.9253 30.6676 14.4713 27.6739 15.2724C24.6828 16.0728 21.7726 17.1202 19.3417 18.096L19.0921 18.1962C17.2544 18.9324 15.9033 19.4739 14.8367 20.6097C13.9476 21.5564 13.2654 22.9218 13.0401 24.2015C12.771 25.7361 13.177 27.2466 13.7325 29.319L13.8132 29.6217L17.5933 43.7424L17.6541 43.9741C18.1101 45.6807 18.4444 46.9346 19.2905 48.0416C19.9731 48.9351 21.1137 49.8183 22.1492 50.2541C23.4336 50.7934 24.5764 50.8006 26.1139 50.8109L26.2911 50.8128C29.3094 50.8347 33.165 50.6014 36.8637 49.6116C40.5636 48.6212 44.0193 46.8982 46.6238 45.3714L46.7763 45.2814C48.1037 44.504 49.0899 43.9266 49.9325 42.8188C50.6122 41.9237 51.1609 40.5882 51.3051 39.4745C51.4849 38.0924 51.1481 36.8391 50.691 35.1331L50.6278 34.9021L46.85 20.7806L46.7683 20.4786C46.2151 18.405 45.8117 16.8942 44.8124 15.6988C43.9793 14.7025 42.7054 13.8608 41.4616 13.4846C39.9717 13.0328 38.5294 13.2391 36.5708 13.5188L36.3028 13.5568ZM19.0988 26.7728C19.6151 28.699 21.5947 29.8424 23.5202 29.3273C25.4467 28.8118 26.5915 26.8321 26.0752 24.9059C25.5601 22.9792 23.5804 21.8357 21.6538 22.3513C19.7273 22.867 18.5838 24.8465 19.0988 26.7728ZM2.87336 31.612C3.48831 31.3432 4.17257 31.3093 4.99075 31.3871C5.79851 31.4636 6.80938 31.6586 8.10209 31.9081L9.36356 32.1511L9.46874 32.1713C10.7163 32.4115 11.4732 32.5574 12.118 32.9139C12.6878 33.2294 13.185 33.6604 13.5779 34.18C14.0218 34.7682 14.2725 35.4971 14.687 36.6985L14.7207 36.7998L14.8706 37.2304L14.9999 37.8839L15.0214 37.9919C15.2779 39.2778 15.4323 40.0577 15.3358 40.8087C15.2518 41.4724 15.0243 42.1092 14.6703 42.6774C14.2696 43.3203 13.6561 43.8256 12.6467 44.6598L12.5613 44.7302L11.6228 45.5046C10.6291 46.3255 9.85132 46.9674 9.19284 47.413C8.52488 47.8649 7.91747 48.1601 7.25977 48.222C6.22363 48.3194 5.13066 47.9791 4.3335 47.308C3.83019 46.8844 3.50149 46.3082 3.21399 45.573C2.92938 44.8492 2.66295 43.906 2.32311 42.7028L2.31533 42.6731C2.1351 42.0382 1.95625 41.3891 1.78184 40.7349C1.625 40.1469 1.4709 39.5617 1.32508 38.9846L1.31729 38.9549C1.00239 37.7175 0.757204 36.7467 0.637607 35.9636C0.517417 35.1681 0.514713 34.4933 0.746299 33.8676C1.11097 32.8793 1.90805 32.0344 2.87336 31.612Z",
    fill: "#B8EAD3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_265_17478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3611 44.4406C28.3611 41.358 30.9832 38.8592 34.2177 38.8592H136.707C139.942 38.8592 142.563 41.358 142.563 44.4406V52.2546H28.3611V44.4406Z",
    fill: "#EAEDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3611 52.2546H142.563V88.3647V124.475C142.563 127.744 139.942 130.395 136.707 130.395H34.2177C30.9832 130.395 28.3611 127.744 28.3611 124.475V52.2546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9148 58.8214H35.9413C34.8316 58.8214 33.932 59.6867 33.932 60.7541C33.932 61.8214 34.8316 62.6867 35.9413 62.6867H60.9148C62.0243 62.6867 62.924 61.8214 62.924 60.7541C62.924 59.6867 62.0243 58.8214 60.9148 58.8214Z",
    fill: "#EAEDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.426 66.8281H39.3859C36.3738 66.8281 33.932 69.1766 33.932 72.0738C33.932 74.9709 36.3738 77.3195 39.3859 77.3195H74.406H109.426C112.438 77.3195 114.88 74.9709 114.88 72.0738C114.88 69.1766 112.438 66.8281 109.426 66.8281Z",
    fill: "#EAEDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.694 84.222H35.9413C34.8316 84.222 33.932 85.0873 33.932 86.1545C33.932 87.2216 34.8316 88.087 35.9413 88.087H105.694C106.804 88.087 107.704 87.2216 107.704 86.1545C107.704 85.0873 106.804 84.222 105.694 84.222Z",
    fill: "#EAEDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5075 90.5718H35.9413C34.8316 90.5718 33.932 91.4372 33.932 92.5044C33.932 93.572 34.8316 94.4373 35.9413 94.4373H65.5075C66.617 94.4373 67.5167 93.572 67.5167 92.5044C67.5167 91.4372 66.617 90.5718 65.5075 90.5718Z",
    fill: "#EAEDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.359 96.9222H35.9413C34.8316 96.9222 33.932 97.7871 33.932 98.8547C33.932 99.9219 34.8316 100.787 35.9413 100.787H64.359C65.4689 100.787 66.3686 99.9219 66.3686 98.8547C66.3686 97.7871 65.4689 96.9222 64.359 96.9222Z",
    fill: "#EAEDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.399 109.07H36.8025C35.2171 109.07 33.932 110.506 33.932 112.278V121.901C33.932 123.673 35.2171 125.109 36.8025 125.109H134.399C135.985 125.109 137.27 123.673 137.27 121.901V112.278C137.27 110.506 135.985 109.07 134.399 109.07Z",
    fill: "#EAEDF5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3611 44.4406C28.3611 41.358 30.9832 38.8592 34.2177 38.8592H136.707C139.942 38.8592 142.563 41.358 142.563 44.4406V52.2546H28.3611V44.4406Z",
    fill: "url(#paint0_linear_265_17478)",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9148 58.8214H35.9413C34.8316 58.8214 33.932 59.6867 33.932 60.7541C33.932 61.8214 34.8316 62.6867 35.9413 62.6867H60.9148C62.0243 62.6867 62.924 61.8214 62.924 60.7541C62.924 59.6867 62.0243 58.8214 60.9148 58.8214Z",
    fill: "url(#paint1_linear_265_17478)",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.426 66.8281H39.3859C36.3738 66.8281 33.932 69.1766 33.932 72.0738C33.932 74.9709 36.3738 77.3195 39.3859 77.3195H74.406H109.426C112.438 77.3195 114.88 74.9709 114.88 72.0738C114.88 69.1766 112.438 66.8281 109.426 66.8281Z",
    fill: "url(#paint2_linear_265_17478)",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.694 84.222H35.9413C34.8316 84.222 33.932 85.0873 33.932 86.1545C33.932 87.2216 34.8316 88.087 35.9413 88.087H105.694C106.804 88.087 107.704 87.2216 107.704 86.1545C107.704 85.0873 106.804 84.222 105.694 84.222Z",
    fill: "url(#paint3_linear_265_17478)",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5075 90.5718H35.9413C34.8316 90.5718 33.932 91.4372 33.932 92.5044C33.932 93.572 34.8316 94.4373 35.9413 94.4373H65.5075C66.617 94.4373 67.5167 93.572 67.5167 92.5044C67.5167 91.4372 66.617 90.5718 65.5075 90.5718Z",
    fill: "url(#paint4_linear_265_17478)",
    fillOpacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.359 96.9222H35.9413C34.8316 96.9222 33.932 97.7871 33.932 98.8547C33.932 99.9219 34.8316 100.787 35.9413 100.787H64.359C65.4689 100.787 66.3686 99.9219 66.3686 98.8547C66.3686 97.7871 65.4689 96.9222 64.359 96.9222Z",
    fill: "url(#paint5_linear_265_17478)",
    fillOpacity: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.399 109.07H36.8025C35.2171 109.07 33.932 110.506 33.932 112.278V121.901C33.932 123.673 35.2171 125.109 36.8025 125.109H134.399C135.985 125.109 137.27 123.673 137.27 121.901V112.278C137.27 110.506 135.985 109.07 134.399 109.07Z",
    fill: "url(#paint6_linear_265_17478)",
    fillOpacity: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.627 38.8592H34.2976C31.019 38.8592 28.3611 41.5171 28.3611 44.7957V124.456C28.3611 127.735 31.019 130.392 34.2976 130.392H136.627C139.905 130.392 142.563 127.735 142.563 124.456V44.7957C142.563 41.5171 139.905 38.8592 136.627 38.8592Z",
    stroke: "#F5F4FB",
    strokeWidth: 0.472222
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.611 70.575C140.728 70.8536 143.215 71.2728 145.663 71.9003C148.111 72.5278 150.493 73.357 152.483 74.1318L152.689 74.2117C154.193 74.7965 155.3 75.2267 156.18 76.1438C156.913 76.9087 157.481 78.0164 157.676 79.0581C157.909 80.3077 157.591 81.5433 157.155 83.2382L154.13 95.0361L154.082 95.2255C153.725 96.6216 153.462 97.647 152.782 98.5575C152.233 99.292 151.31 100.022 150.469 100.386C149.426 100.837 148.494 100.853 147.24 100.874L147.096 100.878C144.634 100.921 141.487 100.764 138.461 99.9879C135.435 99.2122 132.602 97.8356 130.464 96.6128L130.339 96.5407C129.25 95.918 128.44 95.4554 127.744 94.5593C127.182 93.835 126.723 92.7503 126.595 91.8434C126.437 90.7175 126.701 89.6921 127.06 88.2971L130.133 76.3098C130.567 74.6143 130.883 73.3782 131.688 72.3946C132.359 71.575 133.391 70.8777 134.402 70.5596C135.614 70.1791 136.791 70.3346 138.391 70.5464L138.611 70.575ZM152.756 81.2074C152.352 82.7831 150.747 83.7329 149.171 83.3285C147.596 82.9247 146.646 81.3199 147.049 79.7441C147.454 78.1683 149.059 77.2186 150.634 77.623C152.21 78.0268 153.159 79.6316 152.756 81.2074ZM166.032 85.0157C165.528 84.8019 164.97 84.7798 164.303 84.8501C163.645 84.9198 162.822 85.0877 161.769 85.3018L160.743 85.5109L160.658 85.5285C159.642 85.7353 159.026 85.8608 158.503 86.1569C158.04 86.4186 157.639 86.7748 157.323 87.202C156.966 87.6858 156.768 88.2822 156.44 89.2658L156.413 89.3487L156.294 89.7014L156.195 90.2353L156.178 90.3233C155.98 91.3749 155.861 92.0118 155.945 92.6235C156.019 93.1641 156.211 93.6822 156.504 94.1423C156.837 94.6629 157.341 95.0703 158.173 95.7422L158.242 95.7989L159.014 96.4221C159.832 97.0833 160.472 97.6 161.013 97.9582C161.562 98.3214 162.059 98.5566 162.596 98.6013C163.443 98.672 164.331 98.3851 164.975 97.8309C165.382 97.4809 165.646 97.0084 165.874 96.4066C166.1 95.8133 166.309 95.0417 166.576 94.0577L166.582 94.0335C166.723 93.5135 166.864 92.9826 167.001 92.4478C167.124 91.9671 167.244 91.4881 167.358 91.0161L167.364 90.9919C167.61 89.9799 167.803 89.1861 167.893 88.5461C167.984 87.8963 167.981 87.3458 167.787 86.8374C167.48 86.0341 166.823 85.3522 166.032 85.0157Z",
    fill: "#B8EAD3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_265_17478",
    x: 17.0278,
    y: 33.4624,
    width: 136.869,
    height: 114.202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.93651
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.415686 0 0 0 0 0.419608 0 0 0 0 0.47451 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_265_17478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_265_17478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_265_17478",
    x1: 85.4622,
    y1: 38.8592,
    x2: 85.4622,
    y2: 130.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_265_17478",
    x1: 85.4622,
    y1: 38.8592,
    x2: 85.4622,
    y2: 130.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_265_17478",
    x1: 85.4622,
    y1: 38.8592,
    x2: 85.4622,
    y2: 130.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_265_17478",
    x1: 85.4622,
    y1: 38.8592,
    x2: 85.4622,
    y2: 130.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_265_17478",
    x1: 85.4622,
    y1: 38.8592,
    x2: 85.4622,
    y2: 130.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_265_17478",
    x1: 85.4622,
    y1: 38.8592,
    x2: 85.4622,
    y2: 130.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_265_17478",
    x1: 85.4622,
    y1: 38.8592,
    x2: 85.4622,
    y2: 130.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoPlannedConsultation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "no_planned_consultation.688653311ca357a61c3ab32b472617e2.svg";